/**
 * Product Type values must match Monday.com Beer Database Status labels exactly.
 * `label` is the Matrix UI display string when it differs from the stored value.
 */
export const PRODUCT_TYPE_OPTIONS = [
  { value: 'Beer', label: 'Beer', color: 'gold' },
  { value: 'Wine', label: 'Wine', color: 'cyan' },
  { value: 'Wild', label: 'Wild Workshop', color: 'purple' },
  { value: 'Clean Barrel', label: 'Clean Barrel', color: 'orange' },
  { value: 'Clean Wild', label: 'Clean Wild', color: 'magenta' },
  { value: 'Seltzer', label: 'Seltzer', color: 'green' },
  { value: 'Other', label: 'Other', color: 'blue' },
];

export const PRODUCT_TYPE_TAGS = Object.fromEntries(
  PRODUCT_TYPE_OPTIONS.map(({ value, color }) => [value, color]),
);

export const WEBSTORE_REQUEST_TAGS = {
  pending: 'blue',
  approved: 'green',
  rejected: 'red',
  failed: 'red',
};
